import React, { useState, useMemo } from "react";
import { Button, Form } from "react-bootstrap";
import LoadingOverlay from "react-loading-overlay";
// import logo from '../../images/logo.jpg';
import Select from "react-select";
import countryList from "react-select-country-list";

export default function ConfirmDetails({
  details,
  setDetails,
  onConfirm,
  onReDo,
}) {
  const {
    full_name,
    date_of_birth,
    Address,
    Postcode,
    TownCity,
    countryCode,
    Nationality,
  } = details;

  const country_code = countryCode === "GB" ? "UK" : countryCode;

  const [pressed, setPressed] = useState(false);
  const [overlayText, setOverlayText] = useState("Running final checks...");

  const options = useMemo(() => countryList().getData(), []);
  const [nationalitySelection, setNationalitySelection] = useState("");

  // PLEASE PROVIDE YOUR PERSONAL ADDRESS, THIS IS WHERE WE WILL SEND YOUR CARD

  return (
    <LoadingOverlay active={pressed} spinner text={overlayText}>
      <div
        className="loading-overlay"
        style={
          {
            // minHeight: "100vh",
            // width: "100%",
            // display: "flex",
            // justifyContent: "center",
            // alignItems: "center",
            // flexDirection: "column",
            // paddingBottom: 100,
            // paddingTop: 50,
          }
        }
      >
        <p className="widgethead">Confirm your details</p>
        <p>Please provide the address where we will send your card</p>

        <Form.Group className="confirm-details" controlId="confirm">
          <div className="detail name">
            <span className="title">Full Name:</span>
            {full_name}
          </div>

          <div className="detail date">
            <span className="title">Date Of Birth (Year-Month-Day):</span>
            {date_of_birth}
          </div>

          <div className="detail nationality">
            <span className="title">Nationality:</span>
            <Select
              options={options}
              value={nationalitySelection}
              onChange={(x) => {
                setNationalitySelection(x);
                setDetails((prevState) => ({
                  ...prevState,
                  Nationality: x.value,
                }));
              }}
              placeholder={Nationality}
              classNamePrefix="or-select"
            />
          </div>

          <div className="detail postal">
            <span className="title">{`${country_code} Postal Address: `}</span>
            <input
              type="text"
              placeholder="Please add..."
              value={Address}
              className="form-control"
              onChange={(event) => {
                // https://stackoverflow.com/a/56629758/7272124
                const Address = event.target.value;
                setDetails((prevState) => ({ ...prevState, Address }));
              }}
            />
          </div>

          <div className="detail city">
            <span className="title">{`${country_code} Town / City: `}</span>
            <input
              type="text"
              placeholder="Please add..."
              value={TownCity}
              className="form-control"
              onChange={(event) => {
                // https://stackoverflow.com/a/56629758/7272124
                const TownCity = event.target.value;
                setDetails((prevState) => ({ ...prevState, TownCity }));
              }}
            />
          </div>

          <div className="detail pocode">
            <span className="title">{`${country_code} Postal code: `}</span>
            <input
              type="text"
              placeholder="Please add..."
              value={Postcode}
              className="form-control"
              onChange={(event) => {
                // https://stackoverflow.com/a/56629758/7272124
                const Postcode = event.target.value;
                setDetails((prevState) => ({ ...prevState, Postcode }));
              }}
            />
          </div>

          <Button
            variant="dark"
            onClick={() => {
              setPressed(true);
              onConfirm();
            }}
            style={{
              // width: "100%",
              // minWidth: 150,
              // maxWidth: 400,
              // fontWeight: "bold",
            }}
            disabled={
              !(
                Postcode !== "" &&
                Address !== "" &&
                TownCity !== "" &&
                Nationality
              )
            }
          >
            Confirm
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              setOverlayText("Returning to ID verification...");
              setPressed(true);
              onReDo();
            }}
            style={{
              // width: "100%",
              // minWidth: 150,
              // maxWidth: 400,
              // marginTop: 50,
            }}
          >
            Re-do ID verification
          </Button>
          <p className="mt-2">You won't have to re-do our chatbot.</p>
        </Form.Group>
      </div>
    </LoadingOverlay>
  );
}
